import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TEmSalesReportsApi } from './types';

export const emSalesReports: TEmSalesReportsApi = {
	getUploadedFiles: (payload) =>
		http
			.post(endpoint.emSalesReports.UPLOADED_FILES, payload)
			.then((response) => response.data),
	getProcessingTypes: () =>
		http.get(endpoint.emSalesReports.PROCESSING_TYPES).then((response) => response.data),
	processFile: (payload) =>
		http
			.post(endpoint.emSalesReports.PROCESS_FILE, payload.body, {
				params: { id: payload.id },
			})
			.then((response) => response.data),
	downloadFile: (fileId) =>
		http
			.post(endpoint.emSalesReports.DOWNLOAD_FILE(fileId), null, {
				responseType: 'blob',
			})
			.then((response) => response.data),
	getInvoicingFeeTypes: () =>
		http.get(endpoint.emSalesReports.INVOICING_FEE_TYPES).then((response) => response.data),
};
